import http from "../../../../util/axios";

export default {

  //查询文件类型
  getFileType(params){
    return http.get('/app/user/classFile/getFileType',  {params} )
  },

  //资料下载列表
  fileList(params){
    return http.get('/app/user/classFile/fileList',  {params} )
  },

  //完成下载文件记录
  completionDownFile(params){
    return http.get('/app/user/classFile/fileDownload',  {params} )
  },
}



// WEBPACK FOOTER //
// ./src/api/user/course/datadownload/index.js